import { render } from "./GeneracionProyecto.vue?vue&type=template&id=30614ada"
import script from "./GeneracionProyecto.vue?vue&type=script&lang=js"
export * from "./GeneracionProyecto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__